export default "__VITE_ASSET__DUZTvbcF__"